import { useQuery } from 'react-query';
import { queryConsultationSummaryCOM } from './useConsultationSummaryCOM.query';
import {
  ConsultationSummaryCOMResponse,
  UseConsultationSummaryCOMOptions,
} from './useConsultationSummaryCOM.types';

export const CONSULTATION_SUMMARY_COM_QUERY_KEY = 'CONSULTATION_SUMMARY_COM';

export const useConsultationSummaryCOM = (
  consultationId: number,
  options?: UseConsultationSummaryCOMOptions
) => {
  return useQuery<ConsultationSummaryCOMResponse, Error>(
    CONSULTATION_SUMMARY_COM_QUERY_KEY,
    () => queryConsultationSummaryCOM(consultationId),
    {
      retry: false,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};
